export type StudioBqReadPath = 'direct' | 'mcp';

export const STUDIO_BQ_READ_PATH_STORAGE_KEY = 'briefcase.bqReadPath';

// Direct reads only work in prod: staging identities can't read prod BigQuery.
export function canChooseStudioBqReadPath(): boolean {
  return window.configs.APP_ENV === 'production';
}

export function readStudioBqReadPath(): StudioBqReadPath | undefined {
  if (!canChooseStudioBqReadPath()) {
    return undefined;
  }
  try {
    const stored: unknown = JSON.parse(window.localStorage.getItem(STUDIO_BQ_READ_PATH_STORAGE_KEY) ?? 'null');
    return stored === 'direct' || stored === 'mcp' ? stored : undefined;
  } catch {
    return undefined;
  }
}
